import { render } from "./EditHabitacionView.vue?vue&type=template&id=bd315ed6&ts=true"
import script from "./EditHabitacionView.vue?vue&type=script&lang=ts"
export * from "./EditHabitacionView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/femers/git/adminSanatorio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__